module.exports = __webpack_public_path__ + "img/occupancy.58a5435b.png";